export default __webpack_public_path__ + "static/st-like-eldercare-1a587708bc2d578460cb6925e7d5e3e8.png";